export class SharedState {
    constructor() {
        this.state = new Map();
    }
    destroy() {
        this.state.clear();
    }
}
